module.exports = __webpack_public_path__ + "img/hamburguer-menu.aca7e871.svg";